import axios from "axios";
import END_POINTS from "./api";

export const fetchCategories = async () => {
	const response = await axios.get(END_POINTS.categories);
	return response.data.data;
};
